import { Clock } from "lucide-react";
import { type FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useChatbotState, useStartupStatus } from "@noa/client-store";
import { Tag } from "~/components/ui";
import { ChatbotStateTag } from "./chat-status-tag";

export const ChatStatus: FunctionComponent = () => {
  const { t } = useTranslation();
  const chatbotState = useChatbotState();
  // No session yet, so what was sent is held rather than being sent (see `ChatWarmupNotice`).
  const isHeld = useStartupStatus() !== "idle";

  return (
    <div style={{ marginLeft: "36px", marginTop: "-20px" }}>
      {isHeld ? (
        <Tag color="default" className="inline-flex items-center gap-1">
          <Clock size={12} />
          {t("chat:warmup.held")}
        </Tag>
      ) : (
        <ChatbotStateTag state={chatbotState} />
      )}
    </div>
  );
};
